module.exports = __webpack_public_path__ + "assets/img/202109-1.226353f6.png";